import * as Yup from 'yup'

import { BUDGET_DAILY, BUDGET_LIFETIME } from '../../../../../ReusableFormFields/CampaignForms/fields'

export const getValidationSchema = budgetType =>
  Yup.object({
    [budgetType === BUDGET_LIFETIME ? BUDGET_LIFETIME : BUDGET_DAILY]: Yup.string().required('Budget Required')
  })
